<template>
  <nav>
    <v-app-bar dark
               app
               color="primary">

      <img class="header-logo" src="../../assets/logo-branco-sem-fundo.png"
           alt="Logo da Proxpect"/>
      <v-toolbar-title><strong>PROXPECT</strong></v-toolbar-title>

      <v-spacer/>
      <px-ajuda-icon :link="linkAjuda" btn-class=""/>

    </v-app-bar>
  </nav>
</template>

<script>
import { criarConta } from '@/api/ajuda-mapper';

export default {
  data() {
    return {
      linkAjuda: criarConta,
    };
  },
};
</script>

<style scoped>
  .header-logo {
    max-width: 60px;
  }
</style>
